/* eslint-disable */
import React from 'react';
import WaitingUi from '../WaitingUi';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Realtime } from 'services/websocket';
import { routes } from 'routes';
import { realTimeMsg, getMessages } from 'redux/actions';
import { Api } from 'services/api';
import { decodeJwt } from 'utils/decodeJwt';
import { cacheKey } from 'appConstants';
import { cache } from 'utils/cache';

function checkChatReadyStatus({ customerId, threadId, setChatReady }) {
  let tries = 0;
  async function getCheckStatus() {
    ++tries;
    const resp = await Api.getJobChatReadyStatus(customerId, threadId);
    if (resp?.chats && resp.chats.length) {
      setChatReady(true);
    } else {
      if (tries <= 5) {
        setTimeout(getCheckStatus, 1000);
      }
    }
  }
  getCheckStatus();
}

/**
 * Transition UI will render a loading state until the chat session is ready.
 * Once the chat session is ready the UI will redirect to the <Chat /> UI.
 */
export default function Transition() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isAnonInitializing, candidate } = useSelector((state) => state.appReducer);
  const [chatReady, setChatReady] = React.useState(false);

  const messageCallback = (data) => {
    const isChatReady = data.event === 'chatReady' || data.message;
    if (data.event === 'newMessage' && data.message) {
      dispatch(realTimeMsg(data.message));
    }
    setChatReady(isChatReady);
  };

  React.useEffect(() => {
    const jobChatId = cache.get(cacheKey.JOB_CHAT_ID);
    if (chatReady) {
      dispatch(
        getMessages({
          jobChatId,
          candidateId: candidate.id,
          callback: () => history.push(routes.THREAD),
        }),
      );
    }
  }, [chatReady]);

  React.useEffect(() => {
    if (!isAnonInitializing) {
      const token = cache.get(cacheKey.TOKEN);
      if (token) {
        const { customerId, threadId } = decodeJwt(token);
        Realtime.connect({
          onOpenCallback: () => checkChatReadyStatus({ customerId, threadId, setChatReady }),
          onMessageCallback: (data) => messageCallback(data),
        });
      }
    }
  }, [isAnonInitializing]);

  return <WaitingUi />;
}
